import { Id, LaravelResponse, keyToUrl, withDestroyEndpoint, withIndexEndpoint } from "@dgs/core";
import axios from "axios";
import { EventIndexResource } from "../../../../../shared/types/event";
import { IAddEventContactsRequest, IContactOptionResource, IEventUpdateStatusRequest } from "../../types";
import { withEventContactEndpoints } from "./withEventContactEndpoints";

const baseKey = ["events", "archived"];
const contactsKey = (eventId: Id) => [...baseKey, `${eventId}`, "contacts"];
const restoreKey = (eventId: Id) => [...baseKey, `${eventId}`, "restore"];
const contactKey = (eventId: Id, contactId: Id) => [...baseKey, `${eventId}`, "contacts", `${contactId}`];

const updateContactStatusKey = (eventId: Id, contactId: Id) => [
	...baseKey,
	`${eventId}`,
	"contacts",
	`${contactId}`,
	"status",
];

const contactOptionsKey = (eventId: Id) => [...baseKey, `${eventId}`, "contacts", "available-options"];

export const archivedEventService = {
	...withIndexEndpoint<EventIndexResource>(baseKey),
	...withEventContactEndpoints(baseKey),
	...withDestroyEndpoint(baseKey),
	removeContact: (eventId: Id, contactId: Id) => axios.delete(keyToUrl(contactKey(eventId, contactId))),
	addContacts: (eventId: Id, request: IAddEventContactsRequest) => axios.put(keyToUrl(contactsKey(eventId)), request),
	updateContactStatus: (eventId: Id, contactId: Id, request: IEventUpdateStatusRequest) =>
		axios.put(keyToUrl(updateContactStatusKey(eventId, contactId)), request),
	restore: (eventId: Id) => axios.put(keyToUrl(restoreKey(eventId))),
	restoreKey,
	contactOptionsKey,
	contactOptions: (eventId: Id, search?: string, page?: number) =>
		axios.get<LaravelResponse<IContactOptionResource[]>>(keyToUrl(contactOptionsKey(eventId)), {
			params: { search, page },
		}),
};
